var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "panel-container"
  }, [_c('el-tabs', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "active-name": _vm.activeTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.i18nt('designer.hint.widgetSetting'),
      "name": "1"
    }
  }, [_c('el-scrollbar', {
    staticClass: "setting-scrollbar"
  }, [(!!_vm.designer.selectedWidget && !_vm.designer.selectedWidget.category) ? [_c('el-form', {
    staticClass: "setting-form",
    attrs: {
      "model": _vm.optionModel,
      "size": "mini",
      "label-position": "left",
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-collapse', {
    staticClass: "setting-collapse",
    model: {
      value: (_vm.widgetActiveCollapseNames),
      callback: function($$v) {
        _vm.widgetActiveCollapseNames = $$v
      },
      expression: "widgetActiveCollapseNames"
    }
  }, [(_vm.showCollapse(_vm.commonProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "1",
      "title": _vm.i18nt('designer.setting.commonSetting')
    }
  }, [_vm._l((_vm.commonProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showCollapse(_vm.advProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "2",
      "title": _vm.i18nt('designer.setting.advancedSetting')
    }
  }, [_vm._l((_vm.advProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showEventCollapse() && _vm.showCollapse(_vm.eventProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "3",
      "title": _vm.i18nt('designer.setting.eventSetting')
    }
  }, [_vm._l((_vm.eventProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel,
        "event-handled": _vm.getEventHandled(propName)
      }
    }) : _vm._e()]
  })], 2) : _vm._e()], 1)], 1)] : _vm._e(), _vm._v(" "), ((!!_vm.designer.selectedWidget && !!_vm.designer.selectedWidget.category)) ? [_c('el-form', {
    staticClass: "setting-form",
    attrs: {
      "model": _vm.optionModel,
      "size": "mini",
      "label-position": "left",
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-collapse', {
    staticClass: "setting-collapse",
    model: {
      value: (_vm.widgetActiveCollapseNames),
      callback: function($$v) {
        _vm.widgetActiveCollapseNames = $$v
      },
      expression: "widgetActiveCollapseNames"
    }
  }, [(_vm.showCollapse(_vm.commonProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "1",
      "title": _vm.i18nt('designer.setting.commonSetting')
    }
  }, [_vm._l((_vm.commonProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showCollapse(_vm.advProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "2",
      "title": _vm.i18nt('designer.setting.advancedSetting')
    }
  }, [_vm._l((_vm.advProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showEventCollapse() && _vm.showCollapse(_vm.eventProps)) ? _c('el-collapse-item', {
    attrs: {
      "name": "3",
      "title": _vm.i18nt('designer.setting.eventSetting')
    }
  }, [_vm._l((_vm.eventProps), function(editorName, propName) {
    return [(_vm.hasPropEditor(propName, editorName)) ? _c(_vm.getPropEditor(propName, editorName), {
      tag: "component",
      attrs: {
        "designer": _vm.designer,
        "selected-widget": _vm.selectedWidget,
        "option-model": _vm.optionModel,
        "event-handled": _vm.getEventHandled(propName)
      }
    }) : _vm._e()]
  })], 2) : _vm._e()], 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.designer.selectedWidget) ? [_c('el-empty', {
    attrs: {
      "description": _vm.i18nt('designer.hint.noSelectedWidgetHint')
    }
  })] : _vm._e()], 2)], 1), _vm._v(" "), (!!_vm.designer) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.i18nt('designer.hint.formSetting'),
      "name": "2"
    }
  }, [_c('el-scrollbar', {
    staticClass: "setting-scrollbar"
  }, [_c('form-setting', {
    attrs: {
      "designer": _vm.designer,
      "form-config": _vm.formConfig
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dataSource'),
      "name": "3"
    }
  }, [_c('el-scrollbar', {
    staticClass: "ds-setting-scrollbar"
  }, [_c('data-source-setting', {
    attrs: {
      "designer": _vm.designer,
      "form-config": _vm.formConfig
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showWidgetEventDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.setting.editWidgetEventHandler'),
      "visible": _vm.showWidgetEventDialogFlag,
      "show-close": true,
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showWidgetEventDialogFlag = $event
      }
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": _vm.eventHeader
    }
  }), _vm._v(" "), _c('code-editor', {
    ref: "ecEditor",
    attrs: {
      "mode": 'javascript',
      "readonly": false
    },
    model: {
      value: (_vm.eventHandlerCode),
      callback: function($$v) {
        _vm.eventHandlerCode = $$v
      },
      expression: "eventHandlerCode"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": "}"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showWidgetEventDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEventHandler
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.confirm')))])], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd23a5c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/index.vue
// module id = null
// module chunks = 